import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { DataTableCell, DataTableCellElement, DataTableCellProps } from './DataTableCell.js';
import { DataTableRow } from './DataTableTypes.js';

export type DataTableHeaderCellElement = DataTableCellElement;

export type DataTableHeaderCellProps<
  TRow extends DataTableRow,
  TContext = unknown
> = DataTableCellProps<TRow, TContext> & {
  dragHandler?: React.ReactElement;
};

export const DataTableHeaderCell = styled(
  forwardRef(
    <TRow extends DataTableRow, TContext = unknown>(
      { column, ...restProps }: DataTableHeaderCellProps<TRow, TContext>,
      ref: React.ForwardedRef<DataTableHeaderCellElement>
    ) => {
      // @ts-ignore
      return <DataTableCell ref={ref} column={column} {...restProps} />;
    }
  )
).withConfig({
  shouldForwardProp: (propName) => propName !== 'dense',
  displayName: 'DataTableHeaderCell',
})`
  column-gap: 8px;
`;
